<div
    #container
    class="agpr-advancedColorPickerPopover"
    (clickOutside)="close.emit($event)"
>

    <!-- Color Gradient Picker -->
    <div class="agpr-advancedColorPickerPopover-colorpicker-gradient">
        <agpr-color-gradient-picker
            [id]="id + '_popover'"
            [value]="colorModel"
            (colorChange)="onColorGradientChanged($event)">
        </agpr-color-gradient-picker>
    </div>

    @if (showFavoriteColors || showRecentColors || brand) {
        <!-- Swatch Type Selector -->
        <div class="agpr-advancedColorPickerPopover-swatchSelector" >
            <div class="agpr-advancedColorPickerPopover-swatchSelector-dropdown-container">
                <div class="agpr-advancedColorPickerPopover-swatchSelector-dropdown">
                    <agpr-dropdown
                        panelStyleClass="agpr-overlay-dropdown"
                        [disabled]="!showRecentColors && !brand"
                        [id]="id + '_popover_swatchType'"
                        [ariaLabel]="selectedSwatchModel?.label || ''"
                        [options]="selectedSwatchModel ? swatchTypeOptions : []"
                        [ngClass]="{'agpr-advancedColorPickerPopover-swatchSelector-dropdown--border': selectedSwatchType === swatchCollectionType.FAVORITES}"
                        [(ngModel)]="selectedSwatchModel"
                        (ngModelChange)="onSwatchTypeChange($event)"
                        (mousedown)="$event.preventDefault()"
                    ></agpr-dropdown>
                </div>
                @if(selectedSwatchType === swatchCollectionType.FAVORITES) {
                    <div class="agpr-advancedColorPickerPopover-swatchSelector-button">
                        <agpr-button
                            icon="fa-regular fa-duotone fa-gear"
                            [id]="id + '_popover_manageStyles'"
                            [style]="buttonTypes.block"
                            ariaLabel="ColorPicker.manageFavorites"
                            tooltip="ColorPicker.manageFavorites"
                            tooltipPosition="left"
                            (click)="onManageFavoritesClick()"
                        ></agpr-button>
                    </div>
                }
            </div>

            @if (selectedSwatchType === swatchCollectionType.FAVORITES) {
                <div class="agpr-advancedColorPickerPopover-swatchActions">
                    <!-- Add to Favorites button -->
                    @let favoritesAtMax = favoriteColors.length >= MAX_FAVORITE_COLORS;
                    @let buttonLabel = favoritesAtMax ? 'ColorPicker.maxFavoritesReached' : 'ColorPicker.addToFavorites';
                    <agpr-button
                        class="agpr-advancedColorPickerPopover-actionBtn"
                        [class.agpr-advancedColorPickerPopover-actionBtn--disabled]="favoritesAtMax"
                        [ariaLabel]="buttonLabel"
                        [disabled]="favoritesAtMax"
                        [id]="id + '_popover_addFovoriteColor'"
                        icon="fa-regular fa-duotone fa-square-plus"
                        [tooltip]="buttonLabel"
                        tooltipPosition="left"
                        (click)="onAddToFavoritesClick()"
                        [style]="buttonTypes.icon">
                    </agpr-button>
                </div>
            }
        </div>

        <!-- Color Swatches -->
        <div class="agpr-advancedColorPickerPopover-swatches">
            <agpr-color-swatch-grid
                [id]="id + '_popover'"
                [value]="hexInputValue"
                [colors]="selectedSwatchType === swatchCollectionType.RECENT
                    ? recentColors
                    : selectedSwatchType === swatchCollectionType.BRAND
                        ? brandColors
                        : favoriteColors"
                [emptyMessage]="selectedSwatchType === swatchCollectionType.RECENT
                    ? 'ColorPicker.noRecentColors'
                    : selectedSwatchType === swatchCollectionType.BRAND
                        ? 'ColorPicker.noBrandColors'
                        : 'ColorPicker.noFavoriteColors'"
                [showTooltip]="true"
                [ariaLabel]="selectedSwatchModel?.label || ''"
                (colorSelected)="onSwatchColorSelected($event)"
            ></agpr-color-swatch-grid>
        </div>
    }

</div>
